import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { SecondaryPageBackground } from '@sorare/core/src/atoms/ui/SecondaryPageBackground';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LineupsModeSwitcher } from '#src/components/boards/LineupsModeSwitcher/index.tsx';

const DEFAULT_OVERLAY_MID_COLOR = '#757AEB';

const FullHeightContainer = styled(Container)`
  /* Must track the pinned mode switcher height; the portal renders it outside this subtree. */
  --lineups-bottom-bar-height: calc(var(--unit) * 5);
  @media ${laptopAndAbove} {
    --lineups-bottom-bar-height: calc(var(--unit) * 5 + var(--triple-unit));
    align-content: start;
    min-height: calc(
      var(--100vh) - var(--current-stack-height, 0px) - var(
          --lineups-bottom-bar-height
        )
    );
  }
`;

const TopBar = styled(SBHorizontal)`
  padding-block: var(--double-unit);
`;

const ModeSwitcherWrapper = styled.div`
  @media ${laptopAndAbove} {
    padding-block-end: var(--triple-unit);
  }
`;

type Props = PropsWithChildren<{
  fixture?: string;
  filters?: ReactNode;
  overlayMidColor?: string;
}>;

export const LineupsLayout = ({
  fixture,
  filters,
  overlayMidColor = DEFAULT_OVERLAY_MID_COLOR,
  children,
}: Props) => {
  return (
    <>
      <Portal id="shell-background">
        <SecondaryPageBackground overlayMidColor={overlayMidColor} />
      </Portal>
      <FullHeightContainer>
        <TopBar>{filters}</TopBar>
        <Portal id="above-bottom-bar-portal">
          <ModeSwitcherWrapper>
            <LineupsModeSwitcher fixture={fixture} />
          </ModeSwitcherWrapper>
        </Portal>
        {children}
      </FullHeightContainer>
    </>
  );
};
